import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/Socials.module.css";
import { LanguageContext } from "../../Context/changeLanguageProvider";

export function Socials() {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(websiteCurrentLang.content.Socials);
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Socials);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <div className={styles.social}>
      <div className={styles.social_title}>{content.title}</div>
      <div className={styles.social_list}>
        <a
          href={dublicatedcontent?.linkedin_url}
          target="_blank"
          className={styles.social_item}
        >
          <svg
            className={styles.social_icon}
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width="800"
            height="800"
            viewBox="0 0 512 512"
          >
            <path d="M116.504 500.219V170.654H6.975v329.564h109.529v.001zM61.751 125.674c38.183 0 61.968-25.328 61.968-56.953-.722-32.328-23.785-56.941-61.252-56.941C24.994 11.781.5 36.394.5 68.722c0 31.625 23.772 56.953 60.53 56.953h.721v-.001zm115.373 374.545s1.437-298.643 0-329.564H286.67v47.794h-.727c14.404-22.49 40.354-55.533 99.44-55.533 72.085 0 126.116 47.103 126.116 148.333V500.22H401.971V323.912c0-44.301-15.848-74.531-55.497-74.531-30.254 0-48.284 20.38-56.202 40.08-2.897 7.012-3.602 16.861-3.602 26.711v184.047H177.124z" />
          </svg>
        </a>
        <a
          href={dublicatedcontent?.twitter_url}
          target="_blank"
          className={styles.social_item}
        >
          <svg
            className={`${styles.social_icon} ${styles.social_icon_x}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            width="800"
            height="800"
          >
            <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z" />
          </svg>
        </a>
        <a
          href={dublicatedcontent?.instagram_url}
          target="_blank"
          className={styles.social_item}
        >
          <svg
            className={styles.social_icon}
            xmlns="http://www.w3.org/2000/svg"
            width="800"
            height="800"
            viewBox="0 0 20 20"
          >
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M5.87.123C4.242.196 2.83.594 1.69 1.729.548 2.869.155 4.286.081 5.897.037 6.902-.231 14.498.545 16.49a5.04 5.04 0 0 0 2.91 2.903c.634.246 1.356.412 2.416.461 8.86.401 12.145.183 13.53-3.364.246-.631.415-1.353.462-2.41.405-8.883-.066-10.809-1.61-12.351C17.027.507 15.586-.325 5.87.123m.081 17.944c-.97-.043-1.496-.205-1.848-.341a3.255 3.255 0 0 1-1.888-1.883c-.591-1.514-.395-8.703-.342-9.866.051-1.14.282-2.18 1.086-2.985C3.954 2 5.24 1.513 13.993 1.908c1.142.052 2.186.282 2.992 1.084.995.993 1.489 2.288 1.087 11.008-.044.968-.206 1.493-.342 1.843-.901 2.308-2.973 2.628-11.779 2.224M14.09 4.69c0 .657.534 1.19 1.194 1.19.66 0 1.195-.533 1.195-1.19a1.194 1.194 0 0 0-2.39 0M4.864 9.988a5.103 5.103 0 0 0 5.11 5.097 5.103 5.103 0 0 0 5.109-5.097 5.102 5.102 0 0 0-5.11-5.096 5.102 5.102 0 0 0-5.11 5.096m1.794 0A3.313 3.313 0 0 1 9.972 6.68a3.313 3.313 0 0 1 3.317 3.308 3.313 3.313 0 0 1-3.317 3.31 3.313 3.313 0 0 1-3.316-3.31"
            />
          </svg>
        </a>
        <a
          href={dublicatedcontent?.facebook_url}
          target="_blank"
          className={styles.social_item}
        >
          <svg
            className={styles.social_icon}
            xmlns="http://www.w3.org/2000/svg"
            width="800"
            height="800"
            viewBox="-5 0 20 20"
          >
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M6.821 20v-9h2.733L10 7H6.821V5.052C6.821 4.022 6.848 3 8.287 3h1.458V.14c0-.043-1.253-.14-2.52-.14C4.58 0 2.924 1.657 2.924 4.7V7H0v4h2.923v9h3.898Z"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}
